import { TeamRole } from '@anm/api/modules/team';
import FormHelperText from '@anm/components/form/FormHelperText';
import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { UserTeamPermission } from 'types/user';

import RoleRadioBlock from './RoleRadioBlock';
import TeamMemberRolesInputWrapper from './Wrapper';

export type TeamMemberRolesInputProps = FieldRenderProps<TeamRole, HTMLDivElement> & {
  label?: string;
  permissions?: UserTeamPermission;
};

const TeamMemberRolesInput: FC<TeamMemberRolesInputProps> = ({
  input: { value, onChange },
  meta: { error, touched },
  permissions = {}
}) => {
  const { canChangeOwner, canGrantAdmin, canGrantNonAdmin } = permissions;

  return (
    <TeamMemberRolesInputWrapper>
      {touched && <FormHelperText variant="static">{error}</FormHelperText>}
      {canGrantNonAdmin && (
        <>
          <RoleRadioBlock
            features={['Can see team projects and broadcasts']}
            isChecked={value === 'VIEWER'}
            label="Viewer"
            value="VIEWER"
            onChange={onChange}
          />
          <RoleRadioBlock
            features={['Can create, delete and edit his own projects and broadcasts']}
            isChecked={value === 'EDITOR'}
            label="Editor"
            value="EDITOR"
            onChange={onChange}
          />
        </>
      )}
      {canGrantAdmin && (
        <RoleRadioBlock
          features={[
            'Can see, invite and remove team members',
            'Can assign roles for editors and viewers',
            'Can create, delete and edit all team projects and broadcasts'
          ]}
          isChecked={value === 'ADMIN'}
          label="Admin"
          value="ADMIN"
          onChange={onChange}
        />
      )}
      {canChangeOwner && (
        <RoleRadioBlock
          features={[
            'Can see, invite and remove team members',
            'Can manage team subscription and payment details',
            'Can assign roles for all team members ',
            'Can create, delete and edit all team projects and broadcasts'
          ]}
          isChecked={value === 'OWNER'}
          label="Owner"
          value="OWNER"
          onChange={onChange}
        />
      )}
    </TeamMemberRolesInputWrapper>
  );
};
export default TeamMemberRolesInput;
